export type DiagramIcon = {
  name: string;      // stable key stored with diagram (lowercase, simple, e.g., "rocket")
  title: string;     // display label
  color: string;     // hex color code extracted/curated from SVG (e.g., "#4F46E5")
  path: string;      // public path to SVG asset
};

// Minimal starter set. Extend freely over time.
const DIAGRAM_ICONS: DiagramIcon[] = [
  { name: 'rocket', title: 'Rocket', color: '#F5D565', path: '/assets/diagram-icons/Rocket.svg' },
  { name: 'shield', title: 'Shield', color: '#EDACD2', path: '/assets/diagram-icons/Shield-2.svg' },
  { name: 'star', title: 'Star', color: '#9DC4F8', path: '/assets/diagram-icons/Star-Circle.svg' },
  { name: 'tag', title: 'Tag', color: '#F0A9A7', path: '/assets/diagram-icons/Tag.svg' },
  { name: 'bookmark', title: 'Bookmark', color: '#A8B4F6', path: '/assets/diagram-icons/Bookmark.svg' },
  { name: 'calendar', title: 'Calendar', color: '#EDACD2', path: '/assets/diagram-icons/Calendar-Mark.svg' },
  { name: 'folder', title: 'Folder', color: '#A0ECB1', path: '/assets/diagram-icons/New-Folder.svg' },
  { name: 'file', title: 'File', color: '#EDACD2', path: '/assets/diagram-icons/New-File.svg' },
  { name: 'umbrella', title: 'Umbrella', color: '#C9F078', path: '/assets/diagram-icons/Open-Umbrella.svg' },
  { name: 'feather', title: 'Feather', color: '#89E5F6', path: '/assets/diagram-icons/Feather-Pen.svg' },
  { name: 'cog', title: 'Settings', color: '#89E5F6', path: '/assets/diagram-icons/Cog.svg' },
  { name: 'cloud', title: 'Cloud', color: '#C9F078', path: '/assets/diagram-icons/Cloud.svg' },
  { name: 'heart', title: 'Heart', color: '#9DC4F8', path: '/assets/diagram-icons/Heart.svg' },
  { name: 'like', title: 'Like', color: '#F8E164', path: '/assets/diagram-icons/Like-1.svg' },
  { name: 'trophy', title: 'Trophy', color: '#C1B6F8', path: '/assets/diagram-icons/Trophy.svg' },
];

export function getDiagramIcons(): DiagramIcon[] {
  return DIAGRAM_ICONS.slice();
}

export function getDiagramIcon(name: string): DiagramIcon | undefined {
  return DIAGRAM_ICONS.find((i) => i.name === name.toLowerCase());
}

// Defaults (can be tuned later). Native = SQL/Drizzle, Legacy = Mongo.
export function getDefaultNativeDiagramIcon(): DiagramIcon {
  // Prefer something modern and neutral
  return getDiagramIcon('rocket') || DIAGRAM_ICONS[0];
}

export function getDefaultLegacyDiagramIcon(): DiagramIcon {
  // Prefer a conservative, widely-recognized symbol
  return getDiagramIcon('file') || DIAGRAM_ICONS[0];
}
